<template>
    <el-dialog v-model="isVisible" :title="$t('subscription.manage_title')" width="30%">
      <p>{{ $t('subscription.enter_email') }}</p>
  
      <el-form ref="subscriptionForm" :model="form" :rules="rules" label-position="top">
        <el-form-item :label="$t('form_labels.email')"  prop="email">
          <el-input v-model="form.email" :placeholder="$t('form_labels.email_placeholder')" />
        </el-form-item>
      </el-form>
      <template #footer>
            <el-button @click="close">{{ $t('buttons.cancel') }}</el-button>
            <el-button type="secondary" @click="validateAndSubmit">{{ $t('subscription.send_link') }}</el-button>
      </template>
    </el-dialog>
  </template>
  
  <script>
  import { ref, reactive } from "vue";
  import { useI18n } from "vue-i18n";
  import { ElDialog, ElInput, ElButton } from "element-plus";
  import { REQUEST_NEWSLETTER_SUBSCRIPTION_MAGIC_LINK } from "@/graphql/newsletter-subscriptions";
  import { ElNotification } from "element-plus";
  import apolloClient from "@/services/apollo-client";

  export default {
    components: { ElDialog, ElInput, ElButton },
    setup(_, { expose, emit }) {
      const { t } = useI18n();
      const isVisible = ref(false);
      const subscriptionForm = ref(null);

      const form = reactive({
        email: ""
      });
  
      const rules = reactive({
        email: [
          { required: true, message: t("form_rules.email_required"), trigger: "blur" },
          { type: "email", message: t("form_rules.email_invalid"), trigger: ["blur", "change"] }
        ]
      });
  
      const open = () => {
        isVisible.value = true;
      };
  
      const close = () => {
        isVisible.value = false;
      };
  
      const sendMagicLink = async () => {
        try {
          const { data } = await apolloClient.mutate({
            mutation: REQUEST_NEWSLETTER_SUBSCRIPTION_MAGIC_LINK,
            variables: { email: form.email }
          });

          const response = data?.requestNewsletterSubscriptionMagicLink;

          if (response?.success) {
            ElNotification({
              title: t("notifications.success.title"),
              message: t("notifications.subscriptions.magic_link_sent"),
              type: "success"
            });
            close();
            form.email = "";
          } else {
            // 🔍 Handle reason-based messaging
            let message;

            switch (response?.reason) {
              case "USER_NOT_FOUND":
                message = t("notifications.subscriptions.user_not_found");
                break;
              case "NEWSLETTER_SUBSCRIPTION_NOT_FOUND":
                message = t("notifications.subscriptions.subscription_not_found");
                break;
              case "GENERIC":
              default:
                message = response?.message || t("notifications.subscriptions.magic_link_error");
                break;
            }

            ElNotification({
              title: t("notifications.error.title"),
              message,
              type: "error",
              duration: 30000
            });

            if (response?.reason === "USER_NOT_FOUND") {
              setTimeout(() => {
                // Follow-up notification
                ElNotification({
                  title:  t("notifications.subscriptions.subscription_signup_title"),
                  message: t("notifications.subscriptions.subscription_signup_message"),
                  duration: 30000
                });

                close();
                emit('open-subscription-modal');
              }, 2000); // Wait ~700ms before showing next step
            }

          }
        } catch (error) {
          console.error("Magic link request error:", error);
          ElNotification({
            title: t("notifications.error.title"),
            message: error.message || t("notifications.subscriptions.magic_link_error"),
            type: "error"
          });
        }
      };


    const validateAndSubmit = () => {
      subscriptionForm.value.validate(async (valid) => {
          if (valid) {
              await sendMagicLink();
              close();
          }
      });
    };

    expose({ open });

    return {
      t,
      isVisible,
      subscriptionForm,
      form,
      rules,
      open,
      close,
      validateAndSubmit
    };
    }
  };
  </script>
  